import _ from "lodash";
import {convertCamelCaseToSpaceDelimited} from "../commonUtilities";
import {isArrayNullOrEmpty} from "./arrayUtilities";

export function isObjectNullOrEmpty(obj: unknown): boolean {
	return !(obj && Object.getOwnPropertyNames(obj).length !== 0);
}

export function objectHasProperty(object: unknown, property: string): boolean {
	return !isObjectNullOrEmpty(object) && !!Object.prototype.hasOwnProperty.call(object, property);
}

export function deepCopyObject<T>(object: T = {} as T): T {
	return _.cloneDeep(object);
}

export function createObjectFromArray(array: string[]): Record<string, string> {
	let object: Record<string, string> = {};

	if (isArrayNullOrEmpty(array)) return object;

	array.map((item) => {
		return (object = {...object, ...{[item]: item}});
	});

	return object;
}

export function createObjectFromObjectPropertyNames(object: Record<string, unknown>): Record<string, string> {
	let result: Record<string, string> = {};
	for (let property in object) {
		if (objectHasProperty(object, property)) {
			result = {...result, [property]: convertCamelCaseToSpaceDelimited(property)};
		}
	}
	return result;
}

export function getPropertyName(object: Record<string, unknown>, value: unknown): string | undefined {
	let listPropertyNames = Object.keys(object);
	return listPropertyNames.find((f) => object[f] === value);
}

export function getPropertyWithId(object: Record<string, unknown>, value: unknown): unknown {
	const listPropertyNames = Object.keys(object);
	const propertyName = listPropertyNames.find((f) => (object[f] as Record<string, unknown>)?.id === value);
	return !propertyName ? null : object[propertyName];
}

export function getPropertyValue(object: Record<string, unknown>, property: string): unknown {
	return objectHasProperty(object, property) ? object[property] : undefined;
}

export function compareObjects(object1: unknown, object2: unknown): boolean {
	return _.isEqual(object1,object2);
}
